module.exports = __webpack_public_path__ + "static/media/nv-coco.dacc47b1.png";